import { useState, useEffect } from 'react'
import { MdCloudUpload } from 'react-icons/md';
import { useUserAuth } from '../../context/UserAuthContext';
import axios from 'axios';


const ProfilePicture = () => {
    const { user } = useUserAuth();
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const merchant_id = user.uid;

    const [img, setImg] = useState();

    const [image, setImage] = useState(null);

    const [fileName, setFileName] = useState('No selected file');

    const [merchant, setMerchant] = useState({});
    const [imgList, setImgList] = useState('');
    const [imgUrl, setImgUrl] = useState(null);
    const [progresspercent, setProgresspercent] = useState(0);
    const getSingleDocumentHandler = async () => {
        try {
            const apiResponse = await axios.get(`${base_url}/api/v1/profile-picture/${merchant_id}`);
            if (apiResponse.status === 200) {
                const apiData = apiResponse.data;
                setMerchant((prev) => ({
                    ...prev,
                    ...apiData, 
                }));
            } else {
                console.warn('Unexpected API response status:', apiResponse.status);
            }
        } catch (error) {
            console.log(`Error: ${error.message || error}`);
        }
    };
    useEffect(() => {
        if(!merchant_id) return
        getSingleDocumentHandler();
    }, [merchant_id, imgUrl])

    const onChangetHandler = (e) => {
        alert('ok')
        console.log('on chnage file', e.target.files)
    }
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className='card-header bg-white'>
                                <h3>My Profile Picture</h3>
                            </div>
                            <div className='card-body'>
                                <main className="previousWork">
                                    <form action="" onClick={() => document.querySelector('.input-field').click()}>
                                        <input type="file" accept='image/*' className='input-field'
                                            hidden
                                            onChange={(e) => onChangetHandler(e)}
                                        />
                                        {
                                            image ?
                                                <img src={image} width={180} height={180} alt={fileName} style={{ objectFit: 'contain' }} />
                                                :
                                                <>
                                                    <MdCloudUpload color="#1475cf" size={60} />
                                                    <p>Browse File to Upload</p>
                                                </>
                                        }
                                    </form>
                                </main>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProfilePicture